import { render, staticRenderFns } from "./UniButton.vue?vue&type=template&id=8e8c0014&scoped=true"
import script from "./UniButton.vue?vue&type=script&lang=js"
export * from "./UniButton.vue?vue&type=script&lang=js"
import style0 from "./UniButton.vue?vue&type=style&index=0&id=8e8c0014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8c0014",
  null
  
)

export default component.exports